module.exports = __webpack_public_path__ + "static/media/coreAdvisory.b412c8d7.svg";